import React from "react";
import "./socialfooter.css";

function SocialFooter() {
  return (
    <>
      <footer>
        <div style={{ scale: "0.5" }} class="rounded-social-buttons">
          <a
            class="social-button facebook"
            href="https://www.facebook.com/ranee.kaur.banerjee"
            target="_blank">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a
            class="social-button twitter"
            href="https://x.com/raneekb"
            target="_blank">
            <i class="fab fa-twitter"></i>
          </a>
          <a
            class="social-button linkedin"
            href="https://www.linkedin.com/in/raneekaurbanerjee/"
            target="_blank">
            <i class="fab fa-linkedin"></i>
          </a>

          {/* <a
            class="social-button youtube"
            href="https://www.youtube.com/"
            target="_blank">
            <i class="fab fa-youtube"></i>
          </a> */}
          <a
            class="social-button instagram"
            href="https://www.instagram.com/raneekb/"
            target="_blank">
            <i class="fab fa-instagram"></i>
          </a>
          {/* <a
            class="social-button instagram"
            href="https://www.instagram.com/raneekb/"
            target="_blank">
            <i class="fab fa-threads"></i>
          </a> */}
        </div>
      </footer>
      <footer className="copyright">
        © 2025 <strong>Ranee Kaur Banerjee</strong>. All rights reserved. All
        content published on this website is protected by international
        copyright laws. Unauthorized use and/or duplication of this material
        without express and written permission from the author
        [raneekb.writing@gmail.com] is strictly prohibited. You may cite or link
        my work only if you provide full credit and explicit directions to the
        original content.
      </footer>
    </>
  );
}

export default SocialFooter;
